import { Bot } from "lucide-react";

/** Selo do pedido que a CLEO anotou pela conversa do WhatsApp (`pedido.origem === "cleo"`).
 *  O pedido entra como Cardápio; o selo é o que mostra de onde ele veio. */
export default function SeloCleo({ pedido, className = "" }) {
  if (pedido?.origem !== "cleo") return null;
  return (
    <span title="Pedido anotado pela CLEO na conversa do WhatsApp" data-e2e="selo-cleo"
      className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300 ${className}`}>
      <Bot className="w-2.5 h-2.5" />CLEO
    </span>
  );
}
